// @ts-nocheck
import React, { useState } from "react";
import { motion } from "framer-motion";
// Font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCog,
	faEllipsisH,
	faPowerOff,
	faUser,
} from "@fortawesome/free-solid-svg-icons";

import Account from "../Account/Account";
import useAccount from "../hooks/useAccount";
import useToken from "../hooks/useToken";
import UserImage from "components/User/Image/UserImage";
import { t } from "i18next";
import SwitchInput from "components/Inputs/Switch/SwitchInput";
import Storage from "classes/Storage/Storage";
import { CustomPageLink } from "components/Menu/components/PageLink/PageLink";
import Button from "components/Button/Button";
import { useMediaQuery } from "react-responsive";
import { getDeviceInfo } from "includes/pwa_helpers";
import { UAParser } from "ua-parser-js";
import genRequest from "includes/request";
import clearSession from "classes/Accounts/clearSession";

function AccountsMenu(props) {
	const { token } = useToken();
	const { account } = useAccount();
	const storage = new Storage();
	const [CurAccount, setCurAccount] = useState(false);
	const { accountClick, handleRemove } = props;
	const { isReduced, setIsReduced } = props;
	const { device, browser } = getDeviceInfo(new UAParser());

	function handleClick(account) {
		setCurAccount(account);
		accountClick(account);
	}

	function newAccount() {
		setCurAccount("new_account");
		accountClick("new_account");
	}

	function getAccounts() {
		let accounts = [];
		try {
			const accounts_string = storage.getItem("Accounts");
			if (accounts_string?.length) {
				accounts = accounts_string;
				if (accounts)
					accounts = accounts.sort((a, b) => {
						let a_full = a.firstName + " " + a.lastName;
						let b_full = b.firstName + " " + b.lastName;
						if (a_full < b_full) return -1;
						return 1;
					});
			}
		} catch (e) {
			return accounts;
		}
		return accounts;
	}

	let accounts = props.accounts ? props.accounts : getAccounts();
	if (!accounts && !token) return null;

	function OnesignalLogout() {
		// OneSignal SDK v16 throws an internal TypeError ("Cannot read
		// properties of undefined (reading 'Qe')") when logout() runs before
		// the SDK has finished initialising (anon users, e2e sessions, etc.).
		// Guard with a try/catch so our logout flow always completes.
		if (!window.OneSignalDeferred) return;
		window.OneSignalDeferred.push(async function (OneSignal) {
			try {
				await OneSignal.logout();
			} catch (e) {
				// OneSignal SDK internal — swallow; the user-facing logout
				// (sessionStorage.clear + token removal) still runs.
			}
		});
	}

	function sendLogLogout() {
		const hasLogout = sessionStorage.getItem("connectionLogout");
		if (!hasLogout) {
			// type 1 = logout (the API records it once `type` is in its DTO)
			const logRequest = {
				type: 1,
				browser: `${browser?.name?.toLowerCase()}_${browser?.version?.toLowerCase()}`,
				origin: device.isMobile ? 1 : 0,
			};
			sessionStorage.setItem("connectionLogout", "true");
			// short timeout: the caller waits for it before leaving the page,
			// otherwise the browser cancels the in-flight request
			return genRequest("stats/log-connection", logRequest, "post", {
				timeout: 1500,
				skipReport: true,
			}).catch(() => {});
		}
		return Promise.resolve();
	}

	function MultiAccount() {
		let theme = props.theme;
		let cur_theme = props.theme.theme;
		return (
			<div
				className={"accounts-menu"}
				// onMouseLeave={handleMouseLeave}
				onClick={(e) => e.stopPropagation()}
			>
				<div>
					<CurAccountElem
						OnesignalLogout={OnesignalLogout}
						user={account}
						isActive={true}
						// toggleMenu={toggleAccountsMenu}
						handlePageLinks={props.handlePageLinks}
					/>
				</div>
				<div className={"account-menu-body"}>
					<div className="account-menu-links">
						<div
							key="profile"
							onClick={() => props.handlePageLinks("/myonlyall/profile")}
						>
							<CustomPageLink
								activeOnlyWhenExact={true}
								to="/myonlyall"
							>
								<FontAwesomeIcon icon={faUser} />
								{t("Pages.MY_SPACE")}
							</CustomPageLink>
						</div>
						<div
							key="settings"
							onClick={() => props.handlePageLinks("/settings")}
						>
							<CustomPageLink
								activeOnlyWhenExact={true}
								to="/settings"
							>
								<FontAwesomeIcon icon={faCog} />
								{t("Pages.MY_SETTINGS")}
							</CustomPageLink>
						</div>
						<div>
							<a
								href="/#disconnect"
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									OnesignalLogout();
									// log first: the request needs the token,
									// and the page must not leave before it is sent
									sendLogLogout().finally(() => {
										clearSession();
										window.location.assign("/");
									});
								}}
							>
								<FontAwesomeIcon icon={faPowerOff} />
								{t("Accounts.DISCONNECT")}
							</a>
						</div>
						{/* <div className="theme-switch-cont mb-2">
							<SwitchInput
								label={t("Theme.DARK_THEME")}
								checked={
									!cur_theme || cur_theme === "light"
										? false
										: true
								}
								onChange={(elem) => theme.switchTheme(elem)}
							/>
						</div> */}
					</div>
					<div className="accounts-list">
						{accounts.map((user, b) => {
							if (user.employeeId === account.employeeId)
								return null;
							return (
								<AccountElem
									key={user.employeeId || "fallback-" + b}
									user={user}
									onClick={() => {
										clearSession();
										window.location.assign(
											"/" + user.employeeId
										);
									}}
								/>
							);
						})}
					</div>
					<div className="copyrights">
						<a
							href="https://onlyall.fr"
							rel="noreferrer"
							target={"_blank"}
						>
							v{import.meta.env.VITE_VERSION} - OnlyAll
						</a>{" "}
						©{" "}
						<a
							href="https://joonsoft.fr"
							rel="noreferrer"
							target={"_blank"}
						>
							JoonSoft
						</a>
					</div>
				</div>
			</div>
		);
	}

	if (!token) {
		let contAnim = {
			hidden: { opacity: 0 },
			show: {
				opacity: 1,
				transition: {
					when: "beforeChildren",
					staggerChildren: 0.1,
				},
			},
		};

		const itemAnim = {
			hidden: { y: -10, opacity: 0 },
			show: {
				y: 0,
				opacity: 1,
				transition: {
					ease: "easeInOut",
				},
			},
		};

		return (
			<div>
				<motion.div
					variants={contAnim}
					initial="hidden"
					animate="show"
					className={`accounts-list ${
						CurAccount ? "active-cur" : ""
					}`}
				>
					{accounts.map((account) => {
						return (
							<motion.div
								className="account-item-anim"
								variants={itemAnim}
								key={account.employeeId}
							>
								<Account
									handleRemove={() =>
										handleRemove(account.employeeId || account.login)
									}
									isActive={
										CurAccount?.employeeId ===
										account.employeeId
									}
									datas={account}
									onClick={handleClick}
								/>
							</motion.div>
						);
					})}
				</motion.div>
				<div className="text-center" onClick={newAccount}>
					<a href="/#add-account" role="button">
						{t("Accounts.ADD_ACCOUNT")}
					</a>
				</div>
			</div>
		);
	} else return <MultiAccount />;
}

function CurAccountElem({
	user,
	isActive,
	onClick,
	handlePageLinks,
	toggleMenu,
	OnesignalLogout,
}) {
	const storage = new Storage();
	const openProfile = (e) => {
		e.preventDefault();
		e.stopPropagation();
		handlePageLinks("/myonlyall");
	};

	return (
		<div className={"account-menu account-menu-intro"} onClick={onClick}>
			<div className="account-menu-infos w-100">
				<div className="d-flex justify-content-between">
					<div className="w-auto text-intro">
						{t("Commons.WELCOME") + " "}
						{user.firstName +
							(!isActive ? " " + user.lastName : "")}
					</div>
					{/* <CustomPageLink
						activeOnlyWhenExact={true}
						to="/myonlyall"
						onClick={openProfile}
					>
					</CustomPageLink> */}
				</div>
			</div>
			<div
			// key="myonlyall"
			// onClick={(e) => {
			// 	e.preventDefault();
			// 	e.stopPropagation();
			// 	handlePageLinks("/myonlyall");
			// }}
			>
				{/* <CustomPageLink activeOnlyWhenExact={true} to="/myonlyall"> */}
				<UserImage
					companyId={user.companyId}
					employeeId={user.employeeId}
					title={user.firstName + " " + user.lastName}
				/>
				{/* </CustomPageLink> */}
			</div>
		</div>
	);
}
function AccountElem({ user, isActive, onClick, toggleMenu }) {
	let comp_name = user.company?.name;

	return (
		<div
			className={
				"account-menu d-flex align-items-center justify-content-center d-flex gap-2 w-100 cursor-pointer p-1"
			}
			onClick={onClick}
		>
			<UserImage
				companyId={user.companyId}
				employeeId={user.employeeId}
				title={user.firstName + " " + user.lastName}
			/>
			<div className="account-menu-infos w-100">
				<div className="d-flex justify-content-between">
					<div className="w-auto">
						{user.firstName +
							(!isActive ? " " + user.lastName : "")}
						{comp_name?.length > 0 && (
							<div className="company-name">{comp_name}</div>
						)}
					</div>
					{isActive && (
						<Button
							className="w-auto btn-transp btn-h-bg"
							style={{ fontSize: "12px" }}
							title="Menu du compte"
							onClick={toggleMenu}
						>
							<FontAwesomeIcon icon={faCog} color="grey" />
						</Button>
					)}
				</div>
			</div>
		</div>
	);
}

export default AccountsMenu;
